import { render } from "./AdvancesMonthly.vue?vue&type=template&id=0b9e5a50"
import script from "./AdvancesMonthly.vue?vue&type=script&lang=js"
export * from "./AdvancesMonthly.vue?vue&type=script&lang=js"

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__